/* CE Search Page v1.0 — Meilisearch faceted search grid (Fashionphile-style)
   Renders into #CeSearchPage. Facets + live counts + sort + pagination + URL sync. */
(function () {
  'use strict';

  const root = document.getElementById('CeSearchPage');
  if (!root) return;

  const SEARCH_URL = 'https://search.collectoredit.com';
  const TENANT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  const INDEX = 'products';
  const HITS_PER_PAGE = 48;
  const IMG_FROM = 'api.thereluxe.com';
  const IMG_TO = 'search.collectoredit.com';

  // On a collection page this is the collection handle; on the search page it's empty.
  // When set, every query is locked to that collection (in addition to user facets).
  const COLLECTION = root.dataset.collection || '';
  const COLLECTION_TITLE = root.dataset.collectionTitle || '';

  const FACETS = [
    { key: 'brand', label: 'Designer', searchable: true },
    { key: 'category', label: 'Category' },
    { key: 'product_type', label: 'Style' },
    { key: 'color', label: 'Color', swatch: true },
    { key: 'material', label: 'Material' },
    { key: 'condition', label: 'Condition' },
    { key: 'size', label: 'Size' },
    { key: 'badges', label: 'Featured' }
  ];

  // color name -> swatch CSS (mirrors Reluxe's canonical color set)
  const COLOR_HEX = {
    Black: '#111', White: '#fff', Gray: '#9a9a9a', Grey: '#9a9a9a', Brown: '#7a4a23',
    Beige: '#e3d4ba', Tan: '#cda57a', Khaki: '#b5a572', Cream: '#f4ecd8', Ivory: '#fffff0',
    Gold: 'linear-gradient(135deg,#e6c200,#b8860b)', Silver: 'linear-gradient(135deg,#e8e8e8,#9a9a9a)',
    Red: '#c0392b', Burgundy: '#6b1f2a', Pink: '#f4b8c4', Orange: '#e67e22', Yellow: '#f1c40f',
    Green: '#2e7d4f', Blue: '#2d6cdf', Navy: '#1f2a44', Purple: '#7d4f9e',
    Multicolor: 'linear-gradient(135deg,#e74c3c,#f1c40f 35%,#2ecc71 65%,#2d6cdf)', Clear: 'transparent'
  };
  function swatchStyle(name) {
    const v = COLOR_HEX[name];
    if (!v) return 'background:#ddd';
    return (v.indexOf('gradient') !== -1 ? 'background-image:' : 'background:') + v;
  }

  const SORTS = [
    { v: '', label: 'Relevance' },
    { v: 'created_at_timestamp:desc', label: 'Newest' },
    { v: 'price:asc', label: 'Price: Low to High' },
    { v: 'price:desc', label: 'Price: High to Low' },
    { v: 'views_count:desc', label: 'Most Popular' }
  ];

  // ---------- state <-> URL ----------
  const state = { q: '', filters: {}, priceMin: '', priceMax: '', sort: '', page: 1 };

  function readURL() {
    const p = new URLSearchParams(location.search);
    state.q = p.get('q') || '';
    // New arrivals defaults to most-recently-added first
    state.sort = p.get('sort') || ((COLLECTION === 'new' || COLLECTION === 'new-arrivals') ? 'ce_added_ts:desc' : '');
    state.page = parseInt(p.get('page') || '1', 10) || 1;
    state.priceMin = p.get('price_min') || '';
    state.priceMax = p.get('price_max') || '';
    state.filters = {};
    FACETS.forEach(function (f) {
      const v = p.get('f_' + f.key);
      if (v) state.filters[f.key] = v.split('||').filter(Boolean);
    });
  }

  function writeURL() {
    const p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.sort) p.set('sort', state.sort);
    if (state.page > 1) p.set('page', String(state.page));
    if (state.priceMin) p.set('price_min', state.priceMin);
    if (state.priceMax) p.set('price_max', state.priceMax);
    FACETS.forEach(function (f) {
      const v = state.filters[f.key];
      if (v && v.length) p.set('f_' + f.key, v.join('||'));
    });
    history.replaceState(null, '', location.pathname + (p.toString() ? '?' + p.toString() : ''));
  }

  // ---------- query ----------
  function esc(v) { return String(v).replace(/\\/g, '\\\\').replace(/'/g, "\\'"); }

  function buildFilter() {
    const parts = [];
    if ((COLLECTION === 'new' || COLLECTION === 'new-arrivals')) {
      // New In = items added to CE in the last 7 days
      parts.push('ce_added_ts >= ' + (Math.floor(Date.now() / 1000) - 7 * 86400));
    } else if (COLLECTION) {
      parts.push('ce_collections = "' + esc(COLLECTION) + '"');
    }
    Object.keys(state.filters).forEach(function (k) {
      const vals = state.filters[k];
      if (vals && vals.length) {
        parts.push(k + " IN ['" + vals.map(esc).join("','") + "']");
      }
    });
    if (state.priceMin !== '') parts.push('price >= ' + parseFloat(state.priceMin));
    if (state.priceMax !== '') parts.push('price <= ' + parseFloat(state.priceMax));
    return parts.join(' AND ');
  }

  async function query() {
    const body = {
      q: state.q,
      facets: FACETS.map(function (f) { return f.key; }),
      hitsPerPage: HITS_PER_PAGE,
      page: state.page,
      attributesToRetrieve: ['sku', 'title', 'brand', 'price', 'image', 'image2', 'handle_ce', 'condition', 'badges']
    };
    const f = buildFilter();
    if (f) body.filter = f;
    if (state.sort) body.sort = [state.sort];
    const res = await fetch(SEARCH_URL + '/indexes/' + INDEX + '/search', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + TENANT_TOKEN, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    return res.json();
  }

  // ---------- rendering ----------
  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function fmtPrice(p) {
    return '$' + (p || 0).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fixImg(u) { return u ? u.replace(IMG_FROM, IMG_TO) : ''; }

  function skeleton() {
    var heading = (COLLECTION && COLLECTION_TITLE)
      ? '<h1 class="ce-collection-title">' + escapeHtml(COLLECTION_TITLE) + '</h1>' : '';
    return heading + '<div class="ce-sp__layout">' +
      '<aside class="ce-sp__facets" id="CeFacets"></aside>' +
      '<div class="ce-sp__main">' +
      '<div class="ce-sp__topbar">' +
      '<button class="ce-sp__filter-toggle" id="CeFilterToggle" type="button">Filters</button>' +
      '<span class="ce-sp__count" id="CeCount"></span>' +
      '<span class="ce-sp__chips" id="CeChips"></span>' +
      '<select class="ce-sp__sort" id="CeSort" aria-label="Sort by"></select>' +
      '</div>' +
      '<div class="ce-sp__grid" id="CeGrid"></div>' +
      '<div class="ce-sp__pager" id="CePager"></div>' +
      '</div></div>';
  }

  function renderSort() {
    const sel = document.getElementById('CeSort');
    sel.innerHTML = SORTS.map(function (s) {
      return '<option value="' + s.v + '"' + (state.sort === s.v ? ' selected' : '') + '>' + s.label + '</option>';
    }).join('');
    sel.onchange = function () { state.sort = sel.value; state.page = 1; refresh(); };
  }

  function renderFacets(dist) {
    const wrap = document.getElementById('CeFacets');
    wrap.innerHTML = '<div class="ce-sp__facets-head">Filter by' +
      '<button type="button" class="ce-sp__clear" id="CeClearAll">Clear all</button></div>' +
      '<div class="ce-sp__price"><div class="ce-sp__facet-title">Price</div>' +
      '<div class="ce-sp__price-row">' +
      '<input type="number" id="CePriceMin" placeholder="Min" min="0" value="' + escapeHtml(state.priceMin) + '">' +
      '<span>&ndash;</span>' +
      '<input type="number" id="CePriceMax" placeholder="Max" min="0" value="' + escapeHtml(state.priceMax) + '">' +
      '<button type="button" id="CePriceGo">Go</button>' +
      '</div></div>';

    FACETS.forEach(function (f) {
      const counts = (dist && dist[f.key]) || {};
      const selected = state.filters[f.key] || [];
      const names = Object.keys(counts);
      // keep selected values visible even when their count drops out
      selected.forEach(function (v) { if (names.indexOf(v) === -1) names.push(v); });
      if (!names.length) return;
      names.sort(function (a, b) { return (counts[b] || 0) - (counts[a] || 0); });

      const open = selected.length > 0 || f.key === 'brand' || f.key === 'category';
      const sec = el('<details class="ce-sp__facet"' + (open ? ' open' : '') + '><summary>' + f.label +
        (selected.length ? ' <span class="ce-sp__facet-n">' + selected.length + '</span>' : '') +
        '</summary><div class="ce-sp__facet-body"></div></details>');
      const body = sec.querySelector('.ce-sp__facet-body');

      if (f.searchable && names.length > 8) {
        const si = el('<input class="ce-sp__facet-search" type="text" placeholder="Search ' + f.label.toLowerCase() + 's">');
        si.addEventListener('input', function () {
          const t = si.value.toLowerCase();
          body.querySelectorAll('label').forEach(function (lab) {
            lab.style.display = lab.textContent.toLowerCase().indexOf(t) !== -1 ? '' : 'none';
          });
        });
        body.appendChild(si);
      }

      const list = el('<div class="ce-sp__facet-list"></div>');
      names.slice(0, 100).forEach(function (name) {
        const id = 'f-' + f.key + '-' + name.replace(/\W+/g, '-');
        const checked = selected.indexOf(name) !== -1;
        const swatch = f.swatch ? '<span class="ce-sp__swatch" style="' + swatchStyle(name) + '"></span>' : '';
        const lab = el('<label class="ce-sp__opt" for="' + id + '">' +
          '<input type="checkbox" id="' + id + '"' + (checked ? ' checked' : '') + '>' +
          swatch +
          '<span class="ce-sp__opt-name">' + escapeHtml(name) + '</span>' +
          '<span class="ce-sp__opt-count">' + (counts[name] || 0) + '</span></label>');
        lab.querySelector('input').addEventListener('change', function (e) {
          const cur = state.filters[f.key] || [];
          if (e.target.checked) state.filters[f.key] = cur.concat([name]);
          else state.filters[f.key] = cur.filter(function (v) { return v !== name; });
          state.page = 1;
          refresh();
        });
        list.appendChild(lab);
      });
      body.appendChild(list);
      wrap.appendChild(sec);
    });

    document.getElementById('CeClearAll').onclick = function () {
      state.filters = {}; state.priceMin = ''; state.priceMax = ''; state.page = 1; refresh();
    };
    document.getElementById('CePriceGo').onclick = function () {
      state.priceMin = document.getElementById('CePriceMin').value;
      state.priceMax = document.getElementById('CePriceMax').value;
      state.page = 1; refresh();
    };
  }

  function renderChips() {
    const wrap = document.getElementById('CeChips');
    let html = '';
    Object.keys(state.filters).forEach(function (k) {
      (state.filters[k] || []).forEach(function (v) {
        html += '<button type="button" class="ce-sp__chip" data-k="' + k + '" data-v="' + escapeHtml(v) + '">' + escapeHtml(v) + ' &times;</button>';
      });
    });
    if (state.priceMin || state.priceMax) {
      html += '<button type="button" class="ce-sp__chip" data-k="__price">' +
        (state.priceMin ? '$' + state.priceMin : '$0') + '&ndash;' + (state.priceMax ? '$' + state.priceMax : '&infin;') + ' &times;</button>';
    }
    wrap.innerHTML = html;
    wrap.querySelectorAll('.ce-sp__chip').forEach(function (chip) {
      chip.onclick = function () {
        const k = chip.getAttribute('data-k');
        if (k === '__price') { state.priceMin = ''; state.priceMax = ''; }
        else {
          const v = chip.getAttribute('data-v');
          state.filters[k] = (state.filters[k] || []).filter(function (x) { return x !== v; });
        }
        state.page = 1;
        refresh();
      };
    });
  }

  function renderGrid(data) {
    const grid = document.getElementById('CeGrid');
    if (!data.hits.length) {
      grid.innerHTML = '<div class="ce-sp__none">No items match. Try removing a filter.</div>';
      return;
    }
    grid.innerHTML = data.hits.map(function (h) {
      const badge = (h.badges && h.badges.length) ? '<span class="ce-sp__badge">' + escapeHtml(h.badges[0]) + '</span>' : '';
      const img2 = h.image2 ? ' data-alt="' + fixImg(h.image2) + '"' : '';
      return '<a class="ce-sp__card" href="/products/' + (h.handle_ce || '') + '">' +
        '<span class="ce-sp__card-imgwrap">' + badge +
        '<img loading="lazy" src="' + fixImg(h.image) + '"' + img2 + ' alt="' + escapeHtml(h.title) + '"></span>' +
        '<span class="ce-sp__card-brand">' + escapeHtml(h.brand || '') + '</span>' +
        '<span class="ce-sp__card-title">' + escapeHtml(h.title || '') + '</span>' +
        '<span class="ce-sp__card-price">' + fmtPrice(h.price) + '</span>' +
        '</a>';
    }).join('');
    grid.querySelectorAll('img[data-alt]').forEach(function (img) {
      img.addEventListener('mouseenter', function () { const a = img.getAttribute('data-alt'); img.setAttribute('data-alt', img.src); img.src = a; });
      img.addEventListener('mouseleave', function () { const a = img.getAttribute('data-alt'); img.setAttribute('data-alt', img.src); img.src = a; });
    });
  }

  function renderPager(data) {
    const wrap = document.getElementById('CePager');
    const total = data.totalPages || 1;
    if (total <= 1) { wrap.innerHTML = ''; return; }
    let html = '';
    const cur = state.page;
    function btn(p, label, dis) {
      return '<button type="button" class="ce-sp__page' + (p === cur ? ' ce-sp__page--cur' : '') + '"' +
        (dis ? ' disabled' : '') + ' data-p="' + p + '">' + label + '</button>';
    }
    html += btn(cur - 1, '&larr;', cur <= 1);
    const pages = [];
    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || Math.abs(i - cur) <= 2) pages.push(i);
    }
    let prev = 0;
    pages.forEach(function (p) {
      if (p - prev > 1) html += '<span class="ce-sp__ellip">&hellip;</span>';
      html += btn(p, String(p));
      prev = p;
    });
    html += btn(cur + 1, '&rarr;', cur >= total);
    wrap.innerHTML = html;
    wrap.querySelectorAll('.ce-sp__page').forEach(function (b) {
      b.onclick = function () {
        const p = parseInt(b.getAttribute('data-p'), 10);
        if (p >= 1 && p <= total && p !== cur) { state.page = p; refresh(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
      };
    });
  }

  let inflight = 0;
  async function refresh() {
    writeURL();
    const my = ++inflight;
    root.classList.add('ce-sp--loading');
    try {
      const data = await query();
      if (my !== inflight) return;
      document.getElementById('CeCount').textContent =
        (data.totalHits != null ? data.totalHits : (data.estimatedTotalHits || 0)).toLocaleString() +
        (state.q ? ' results for “' + state.q + '”' : ' items');
      renderFacets(data.facetDistribution);
      renderChips();
      renderGrid(data);
      renderPager(data);
      renderSort();
    } finally {
      if (my === inflight) root.classList.remove('ce-sp--loading');
    }
  }

  // live re-query when typing in the on-page search input (Fashionphile feel)
  function bindLiveInput() {
    const input = document.querySelector('.search-page-input, input[type="search"][name="q"]');
    if (!input) return;
    let t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        state.q = input.value.trim();
        state.page = 1;
        refresh();
      }, 200);
    });
  }

  // mobile filters toggle
  function bindToggle() {
    document.getElementById('CeFilterToggle').onclick = function () {
      root.classList.toggle('ce-sp--facets-open');
    };
  }

  readURL();
  root.innerHTML = skeleton();
  var _ceIntro = document.getElementById('CeCollectionIntro');
  var _ceH1 = root.querySelector('h1.ce-collection-title');
  if (_ceIntro && _ceH1) { _ceH1.insertAdjacentElement('afterend', _ceIntro); }
  renderSort();
  bindToggle();
  bindLiveInput();
  refresh();
})();
